export default __webpack_public_path__ + "static/media/gallery_welcome.448efa48.png";